import type { ChatEvent, ToolCallDisplay } from '../types'

export interface StreamingState {
  isStreaming: boolean
  currentAssistantEventId?: string | undefined
}

export type AgentStreamAction =
  | { type: 'SET_EVENTS'; events: ChatEvent[] }
  | { type: 'CLEAR_EVENTS' }
  | { type: 'ADD_EVENT'; event: ChatEvent }
  | {
      type: 'UPDATE_ASSISTANT'
      id: string
      content: string
      isStreaming: boolean
    }
  | {
      type: 'UPDATE_THINKING'
      id: string
      content: string
      isStreaming: boolean
    }
  | { type: 'UPDATE_TOOL_CALL'; id: string; patch: Partial<ToolCallDisplay> }
  | { type: 'COMPLETE_STREAM' }

export function agentStreamReducer(
  state: ChatEvent[],
  action: AgentStreamAction
): ChatEvent[] {
  switch (action.type) {
    case 'SET_EVENTS':
      return action.events

    case 'CLEAR_EVENTS':
      return []

    case 'ADD_EVENT':
      return [...state, action.event]

    case 'UPDATE_ASSISTANT':
      return state.map((evt) =>
        evt.id === action.id && evt.type === 'assistant_message'
          ? { ...evt, content: action.content, isStreaming: action.isStreaming }
          : evt
      )

    case 'UPDATE_THINKING':
      return state.map((evt) =>
        evt.id === action.id && evt.type === 'thinking_message'
          ? { ...evt, content: action.content, isStreaming: action.isStreaming }
          : evt
      )

    case 'UPDATE_TOOL_CALL':
      return state.map((evt) =>
        evt.id === action.id && evt.type === 'tool_call'
          ? { ...evt, ...action.patch }
          : evt
      )

    case 'COMPLETE_STREAM':
      return state.map((evt) => {
        if (evt.type === 'assistant_message' && evt.isStreaming)
          return { ...evt, isStreaming: false }
        if (evt.type === 'thinking_message' && evt.isStreaming)
          return { ...evt, isStreaming: false }
        return evt
      })

    default:
      return state
  }
}
